<template>
    <div class="swiper home-banner-bg">
        <div class="swiper-wrapper">
            <div v-for="banner in bannerSlides" :key="banner.displayText + ' background'" 
                 :class="['swiper-slide', {'background-darken' : banner.slideImageDarken}]">
                <div>
                    <span v-if="banner.slideImageDarken" class="background-darken-overlay"></span>
                    <img :src="getImageUrl(banner.slideImage.urls[0])" alt=""
                        :class="[{ 'd-none d-lg-block mx-auto' : isMobileBanner(banner) }]" />
                    <img :src="getImageUrl(banner.slideImageMobile.urls[0])" class="d-lg-none" alt=""
                        v-if="isMobileBanner(banner)" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import SwiperCore, { Navigation, Pagination } from 'swiper/core';
    SwiperCore.use([Navigation, Pagination]);

    export default {
        data() {
            return {
                swiper: null,
                bannerSlides: [{ "slideImageDarken": true, "slideImage": { "urls": [""] } }],
                cmsBaseUrl: process.env.VUE_APP_CMS_BASE_URL,
            }
        },
        props: ["banner"],
        watch: {
            banner: {
                handler() {
                    if (this.banner) {
                        this.bannerSlides = this.banner;
                        this.$nextTick(() => {
                            this.swiperInnit();
                        })
                    }
                }
            }
        },
        mounted() {
            window.addEventListener('resize', this.reinnitSwiper);
            this.swiperInnit();
        },
        unmounted() {
            window.removeEventListener('resize', this.reinnitSwiper);
        },
        methods: {
            swiperInnit() {
                this.swiper = new Swiper('.home-banner-bg', {
                    slidesPerView: 1,
                    loop: true,
                    pagination: {
                        el: '#HomeHeader .swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '#HomeHeader .swiper-button-next',
                        prevEl: '#HomeHeader .swiper-button-prev',
                    },
                });
            },
            isMobileBanner(banner) {
                return banner.slideImageMobile && banner.slideImageMobile.urls && banner.slideImageMobile.urls.length > 0;
            },
            reinnitSwiper() {
                this.swiper.update();
            },
            getBaseUrl() {
                var IS_STAG = window.location.host.indexOf("inprogress") > -1 || window.location.host.indexOf("localhost") > -1;
                if (IS_STAG) this.cmsBaseUrl = 'https://dunloptyres-oc-qa.azurewebsites.net';

                return this.cmsBaseUrl;
            },
            getImageUrl(imagePath) {
                var fullPath = this.getBaseUrl() + imagePath;
                return fullPath;
            }
        }
    };
</script>